import * as React from "react";
import { instance } from "Services/instance";
import { useTranslation } from "react-i18next";
import BottomSheet from "Components/BottomSheet";
import { format } from "react-string-format";
import Icon from "Components/Icon";

const BottomSheetSelect = (props: any) => {
  const [t] = useTranslation();
  const [loading, setLoading] = React.useState<boolean>(true);
  const [loaded, setLoaded] = React.useState<boolean>(false);
  const [options, setOptions] = React.useState<any[]>([]);
  const [open, setOpen] = React.useState(false);
  const [filter, setFilter] = React.useState("");
  const [selectedValue, setSelectedValue] = React.useState<any>([]);

  

  React.useEffect(() => {
    if (props.value || props.value == 0)
      setSelectedValue(
        props.value.value || props.value.value == 0
          ? props.value.value
          : props.value
      );
    else setSelectedValue(null);
  }, [props.value]);

  const handleClickOpen = (e: any) => {
    e.preventDefault();
    setOpen(true);
  };

  const handleClose = (data: any) => {
    if (data) {
      setSelectedValue(data.value);
      props.onChange(data);
    }
    setOpen(false);
  };

  React.useEffect(() => {
    if (
      props.url &&
      !String(props.url).endsWith("?") &&
      !String(props.url).includes("undefined")
    )
      loadData();
  }, [props.url]);

  React.useEffect(() => {
    if (props.options && props.options.length) {
      setLoading(false);
      setLoaded(true);
    }
  }, [props.options]);

  const loadData = async () => {
    await instance.get(props.url, { timeout: 10000 })
      .then((res) => {
        if (res.status === 200) {
          if (props.mapper) {
            const SelectFormat = props.mapper(res.data);
            setOptions(SelectFormat);
            if (props.onCompleteLoad) props.onCompleteLoad(SelectFormat);
          } else if (props.isTree) {
            setOptions(res.data);
            if (props.onCompleteLoad) props.onCompleteLoad(res.data);
          } else {
            const SelectFormat = res.data.map((item: any) => ({
              value: item.id,
              label: item.title,
            }));
            setOptions(SelectFormat);
            if (props.onCompleteLoad) props.onCompleteLoad(SelectFormat);
          }
          setLoading(false);
          setLoaded(true);
        }
      })
      .catch((error) => {
        setLoading(false);
        console.error(error)
      });
  };

  if (loading)
    return (
      <div
        className={`group form-floating w-full relative ${props.errors ? ` validation-error` : ``} `}
      >
        <input
          id={props.id}
          name={props.name}
          type="text"
          className="form-select peer "
          placeholder=""
          autoComplete="off"
          disabled={props.disabled}
          value={
            props.url
              ? (options.find((x) => x.value == selectedValue)?.label ?? "")
              : (props.options.find((x: any) => x.value == selectedValue)
                  ?.label ?? "")
          }
        />
        <label
          htmlFor={props.id}
          className="peer-focus:text-xs peer-focus:-top-[8px] peer-focus:text-gray-800 dark:peer-focus:text-white peer-placeholder-shown:text-lg peer-placeholder-shown:top-3"
        >
          <span className="relative">
            {props.label}
            {props.rules?.required && (
              <span style={{ color: "#d84b4b" }}>*</span>
            )}
          </span>
        </label>

        {props.errors && (props.errors?.type as any) === "required" && (
          <div className="text-error text-xs mt-1 hidden group-[.validation-error]:block">
            {props.errors?.message
              ? props.errors.message
              : format(t("VALIDATION_ERROR_REQUIRED"), props.label)}
          </div>
        )}
      </div>
    );
  else if (loaded && (options || props.options))
    return (
      <React.Fragment>
        <div
          className={`group form-floating w-full relative ${props.errors ? ` validation-error` : ``} ${props.contentCalssName}`}
        >
          <input
            style={props.style}
            id={props.id}
            name={props.name}
            type="text"
            className={props.classNameInput ? "" : "form-select peer"}
            placeholder=""
            ref={props.ref}
            autoComplete="off"
            disabled={props.disabled}
            value={
              props.url
                ? (options.find((x) => x.value == selectedValue)?.label ?? "")
                : (props.options.find((x: any) => x.value == selectedValue)
                    ?.label ?? "")
            }
            onFocus={handleClickOpen}
          />
          <label
            htmlFor={props.id}
            className="peer-focus:text-xs peer-focus:-top-[8px] peer-focus:text-gray-800 dark:peer-focus:text-white peer-placeholder-shown:text-lg peer-placeholder-shown:top-3"
          >
            <span className="relative">
              {props.label}
              {props.rules?.required && (
                <span style={{ color: "#d84b4b" }}>*</span>
              )}
            </span>
          </label>

          {props.errors && (props.errors?.type as any) === "required" && (
            <div className="text-error text-xs mt-1 hidden group-[.validation-error]:block">
              {props.errors.message
                ? props.errors.message
                : format(t("VALIDATION_ERROR_REQUIRED"), props.label)}
            </div>
          )}
        </div>

        <BottomSheet
          title={props.label}
          visible={open}
          onCancel={() => setOpen(false)}
        >
          <div
            style={{
              width: 50,
              height: 6,
              backgroundColor: "#ccc",
              borderRadius: 3,
              position: "absolute",
              top: 8,
              left: "50%",
              transform: "translateX(-50%)",
            }}
          />
          <div className="overflow-auto px-6 pb-6">
            <div className="text-black text-sm mb-4">{`${props.label} را مشخص کنید.`}</div>
            {props.withSearch && (
  <div className="group form-floating w-full relative mb-2">
    <input
      id="searchInput"
      type="text"
      className="form-text form-sm peer pl-9"
      placeholder=""
      onChange={(e) => {
        setFilter(e.target.value)
        if (props.onInputChange) props.onInputChange(e.target.value) // ⚡ اضافه شد
      }}
    />
    <label
      htmlFor="searchInput"
      className="peer-focus:text-xs peer-focus:-top-[8px] peer-focus:text-gray-800 dark:peer-focus:text-white peer-placeholder-shown:text-lg peer-placeholder-shown:top-1"
    >
      <span className="relative">{`${t("SEARCH")} ${props.label}`}</span>
    </label>
    <Icon
      name="search-normal"
      className="w-5 h-5 absolute left-3 top-[.6rem]"
    />
  </div>
)}

            {props.url
              ? options
                  .filter(
                    (option) => filter == "" || option.label.includes(filter)
                  )
                  .map((option, index) => (
                    <label
                      className="flex items-center gap-2 py-2"
                      onClick={() => handleClose(option)}
                    >
                      <div className="grow flex items-center gap-2 font-semibold text-sm">
                        {option.icon ? (
                          <img
                            src="assets/images/_temp/logo-irankhodro.jpg"
                            className="w-8 h-8"
                          />
                        ) : (
                          ""
                        )}
                        {option.label}
                      </div>
                      <input
                        type="radio"
                        name="status"
                        className="radio-primary"
                        checked={option.value == selectedValue}
                      />
                    </label>
                  ))
              : props.options
                  .filter(
                    (option: any) =>
                      filter == "" || option.label.includes(filter)
                  )
                  .map((option: any, index: number) => (
                    <label
                      className="flex items-center gap-2 py-2"
                      onClick={() => handleClose(option)}
                    >
                      <div className="grow flex items-center gap-2 font-semibold text-sm">
                        {option.icon ? (
                          <img
                            src="assets/images/_temp/logo-irankhodro.jpg"
                            className="w-8 h-8"
                          />
                        ) : (
                          ""
                        )}
                        {option.label}
                      </div>
                      <input
                        type="radio"
                        name="status"
                        className="radio-primary"
                        checked={option.value == selectedValue}
                      />
                    </label>
                  ))}
          </div>
        </BottomSheet>
      </React.Fragment>
    );
  else
    return (
      <div
        className={`group form-floating w-full relative ${props.errors ? ` validation-error` : ``}`}
      >
        <input
          id={props.id}
          name={props.name}
          type="text"
          className={props.classNameInput ? "hi" : "form-select peer"}
          placeholder=""
          autoComplete="off"
          disabled={props.disabled}
          value={
            props.url
              ? (options.find((x) => x.value == selectedValue)?.label ?? "")
              : (props.options.find((x: any) => x.value == selectedValue)
                  ?.label ?? "")
          }
        />
        <Icon
          name="rotate-left"
          className="w-6 h-6"
          style={{ position: "absolute", top: "15px", right: "5px" }}
          onClick={() => loadData()}
        />
        <label
          htmlFor={props.id}
          className="peer-focus:text-xs peer-focus:-top-[8px] peer-focus:text-gray-800 dark:peer-focus:text-white peer-placeholder-shown:text-lg peer-placeholder-shown:top-3"
        >
          <span className="relative">
            {props.label}
            {props.rules?.required && (
              <span style={{ color: "#d84b4b" }}>*</span>
            )}
          </span>
        </label>

        {props.errors && (props.errors?.type as any) === "required" && (
          <div className="text-error text-xs mt-1 hidden group-[.validation-error]:block">
            {props.errors.message
              ? props.errors.message
              : format(t("VALIDATION_ERROR_REQUIRED"), props.label)}
          </div>
        )}
      </div>
    );
};

export default BottomSheetSelect;
